"use client";

import { c as _c } from "react/compiler-runtime";
import type { ItemMarketingName } from "@sticker-giant/sg-frontend-common";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { trackProductSelected } from "@/lib/analytics/segment";
import { usePdpStore } from "@/stores/usePdpStore";
import OptionLabel from "./OptionLabel";
import { useProductBuilderContext } from "./ProductBuilderContext";
import { useProductMicrocopy } from "./useProductMicrocopy";
export default function Product() {
  const $ = _c(28);
  const {
    product,
    resolvedWrappers
  } = useProductBuilderContext();
  const productSku = usePdpStore(_temp);
  const selectProduct = usePdpStore(_temp2);
  const microcopyFields = useProductMicrocopy();
  const productLabel = microcopyFields?.productLabel ?? "Product";
  const productHelper = microcopyFields?.productLabelHelper;
  const productControlIdBase = `product-${product.sku}`;
  const productLabelId = `${productControlIdBase}-label`;
  const productHelpDialogId = `${productControlIdBase}-help-dialog`;
  const productSelectContentId = `${productControlIdBase}-select-content`;
  const currentValue = productSku ?? product.sku;
  if (resolvedWrappers.length <= 1) {
    return null;
  }
  let t0;
  if ($[0] !== productHelpDialogId || $[1] !== productHelper || $[2] !== productLabel || $[3] !== productLabelId) {
    t0 = <OptionLabel id={productLabelId} label={productLabel} helper={productHelper} helpDialogId={productHelpDialogId} />;
    $[0] = productHelpDialogId;
    $[1] = productHelper;
    $[2] = productLabel;
    $[3] = productLabelId;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  let t1;
  if ($[5] !== selectProduct) {
    t1 = value => {
      const sku = value as ItemMarketingName;
      selectProduct(sku);
      trackProductSelected(sku);
    };
    $[5] = selectProduct;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const t2 = product.shortDescription ? "product-description" : undefined;
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <SelectValue placeholder="-- Select Product --" />;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== productLabelId || $[9] !== productSelectContentId || $[10] !== t2) {
    t4 = <SelectTrigger aria-labelledby={productLabelId} aria-describedby={t2} aria-controls={productSelectContentId} className="w-full">{t3}</SelectTrigger>;
    $[8] = productLabelId;
    $[9] = productSelectContentId;
    $[10] = t2;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== resolvedWrappers) {
    t5 = resolvedWrappers.map(_temp3);
    $[12] = resolvedWrappers;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== productSelectContentId || $[15] !== t5) {
    t6 = <SelectContent id={productSelectContentId}>{t5}</SelectContent>;
    $[14] = productSelectContentId;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== currentValue || $[18] !== t1 || $[19] !== t4 || $[20] !== t6) {
    t7 = <Select value={currentValue} onValueChange={t1}>{t4}{t6}</Select>;
    $[17] = currentValue;
    $[18] = t1;
    $[19] = t4;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== product.shortDescription) {
    t8 = product.shortDescription && <p id="product-description" className="text-sm text-muted-foreground">{product.shortDescription}</p>;
    $[22] = product.shortDescription;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] !== t0 || $[25] !== t7 || $[26] !== t8) {
    t9 = <div className="flex flex-col gap-1">{t0}{t7}{t8}</div>;
    $[24] = t0;
    $[25] = t7;
    $[26] = t8;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  return t9;
}
function _temp3(t0) {
  const {
    product: childProduct,
    productWrapper: childWrapper
  } = t0;
  return <SelectItem key={childProduct.sku} value={childProduct.sku}>{childWrapper.titleOverride ?? childProduct.title}</SelectItem>;
}
function _temp2(state_0) {
  return state_0.selectProduct;
}
function _temp(state) {
  return state.productSku;
}